import { post } from "../../../../../helper/api";
import { message } from "../../../../../components/toast";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { FileUpload, columnMap, sheet } from "../../../type";
import { fileList, sheet as jobSheet, columnMap as jobColumnMap } from "./type";
import { generateCsvBlob, filterSelectedRows } from "../utility";

export const handleSubmit = async (
  values: {
    name: string;
    startDate: Date | undefined;
    endDate: Date | undefined;
    jobStartWithSubmit: boolean;
  },
  fileUpload: FileUpload[],
  selectedRowIdsBySheet: { [key: number]: number[] },
  selectedRowsDataBySheet: { [key: number]: any[] },
  selectedSheetIndex: number,
  app: any,
  api: any,
  closeAddUpdate: () => void,
  isUpdate: boolean,
  selectedFunction: any,
  loader: any,
  navigate: ReturnType<typeof useNavigate>,
  location: ReturnType<typeof useLocation>,
  auth: any
) => {
  // Check if at least one sheet has selected records
  let hasSelectedRecords = false;
  for (const index in selectedRowIdsBySheet) {
    if (selectedRowIdsBySheet[index].length > 0) {
      hasSelectedRecords = true;
      break;
    }
  }
  if (!hasSelectedRecords) {
    message("warning", "Please select at least one record from any sheet before submitting.");
    return;
  }

  let formData = new FormData();
  const fileList: fileList[] = [];

  // Process all sheets with selected records
  fileUpload.forEach((item: FileUpload, index: number) => {
    if (
      item.selectedSheet &&
      item.totalSheet &&
      item.totalSheet.length > 0 &&
      item.totalSheet[0] &&
      item.totalSheet[0].rowData &&
      item.totalSheet[0].sourceColumnList &&
      item.totalSheet[0].sourceColumnList[0]
    ) {
      const selectedRowIds = selectedRowIdsBySheet[index] || [];
      if (selectedRowIds.length === 0) {
        return;
      }

      const filteredRowData = filterSelectedRows(item.totalSheet[0].rowData, selectedRowIds);
      const fileType = item.file.name.split(".").pop()?.toLowerCase();
      let blob: Blob;

      if (fileType === "csv") {
        blob = generateCsvBlob(filteredRowData, item.totalSheet[0].sourceColumnList[0]);
      } else if (fileType === "xlsx" || fileType === "xls") {
        const worksheetData = [item.totalSheet[0].sourceColumnList[0], ...filteredRowData];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          XLSX.utils.aoa_to_sheet(worksheetData),
          item.selectedSheet[0]?.name || `Sheet${index + 1}`
        );
        const xlsxBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        blob = new Blob([xlsxBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      } else {
        message("error", `Unsupported file format for ${item.file.name}.`);
        return;
      }

      //       const url = window.URL.createObjectURL(blob);
      // const link = document.createElement("a");
      // link.href = url;
      // link.download = `mutated_${item.file.name}`;
      // link.click();
      // window.URL.revokeObjectURL(url);

      const updatedFile = new File([blob], item.file.name, {
        type: fileType === "csv" ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        lastModified: new Date().getTime(),
      });
      formData.append("files", updatedFile);

      fileList.push({
        name: item.file.name,
        sheetList: item.selectedSheet.map<jobSheet>((sheet: sheet) => ({
          name: sheet.name,
          functionCode: sheet.functionCode,
          columnMap: sheet.columnMap
            ?.map<jobColumnMap>((map: columnMap) => ({
              destinationCode: map.DestinationCode,
              source: map.Source,
            }))
            .filter((x) => x.source.toString().trim().length > 0),
        })),
      });
    } else {
    }
  });

  const currentSheetRowData = fileUpload[selectedSheetIndex]?.totalSheet?.find(
    (sheet: any) => sheet.name === fileUpload[selectedSheetIndex]?.selectedSheet?.[0]?.name
  )?.rowData || [];
  const filteredRowData = filterSelectedRows(currentSheetRowData, selectedRowIdsBySheet[selectedSheetIndex] || []);
  const updatedFileUpload = [...fileUpload];
  const matchedTotalSheet = fileUpload[selectedSheetIndex]?.totalSheet?.find(
    (sheet: any) => sheet.name === fileUpload[selectedSheetIndex]?.selectedSheet?.[0]?.name
  );
  if (matchedTotalSheet) {
    updatedFileUpload[selectedSheetIndex].totalSheet = [
      { ...matchedTotalSheet, rowData: filteredRowData },
    ];
  }

  formData.append(
    "fileList",
    JSON.stringify({
      name: values.name,
      jobStartWithSubmit: true,
      tenantId: app.conversation.tenant[0].id,
      isUpdate: isUpdate || false,
      fileList: fileList,
      functionList: app.currentApp.appCode === "rdo" ? selectedFunction : undefined,
      startDate: values.startDate,
      endDate: values.endDate,
      mappedData: selectedRowsDataBySheet[selectedSheetIndex] || [],
    })
  );

  let response = await post("/job", formData, undefined, loader);
  if (response && response.status) {
    try {
      if (!app.conversation && location.pathname === "/modification") {
        navigate("/");
      }
      const path = location.pathname;
      const isModification: any = path.includes("/modification");
      if (isModification) {
        if (auth.user?.role === "User") {
          navigate(`/${auth.user?.loginType}/job`, {
            state: { action: "save", data: app.conversation },
          });
        } else {
          navigate("/job", {
            state: { action: "save", data: app.conversation },
          });
        }
      }
      api.mutate();
      closeAddUpdate();
    } catch (error) {
      console.error("Error During Navigation:", error);
    }
  } else {
    console.error("API Response Failed:", response);
  }
};